import { UseQueryResult } from '@tanstack/react-query';
import { UserCredentialsPaginatedResponse } from 'interfaces/userCredentials';
import { usePaginatedUserCredentials } from 'utils/queryHooks/usePaginatedUserCredentials';
import { useCurrentLabId } from './useCurrentLab';

export const useCurrentLabUsers = (studyId?: string): UseQueryResult<UserCredentialsPaginatedResponse> => {
  const { labId } = useCurrentLabId();

  return usePaginatedUserCredentials({
    labId,
    listNucleaiUsers: false,
    studyId,
    queryKeyPrefix: 'labUserProfiles',
  });
};
